import { useAuth } from '../../../helpers/AuthContext';
import useNavAlerts, {
  compareNavCounts,
  parseNavAlertPreview,
} from '../../Nav/useNavAlerts';

const COUNT_KEYS = ['orders', 'reviews', 'messages'];
const ITEM_COUNT_KEYS = {
  'manage-orders': 'orders',
  reviews: 'reviews',
  messages: 'messages',
};

export function parseSellerNavAlertPreview(search) {
  return parseNavAlertPreview(search, 'sellerNavAlerts', COUNT_KEYS);
}

export function getSellerNavStorageKey(channel) {
  const channelKey = channel?.uuid || channel?.id;
  return channelKey ? `mayhem:seller-nav-counts:${channelKey}` : null;
}

export function compareSellerNavCounts(counts, baseline) {
  return compareNavCounts(counts, baseline, COUNT_KEYS);
}

/** Seller-specific identity and endpoint adapter over the shared browser-local alert state. */
export default function useSellerNavAlerts(activeItemId) {
  const { fetch: authFetch, API_URL, channel } = useAuth();

  return useNavAlerts({
    fetch: authFetch,
    apiBase: API_URL,
    endpoint: '/v1/seller/sidebar/counts',
    storageKey: getSellerNavStorageKey(channel),
    previewParam: 'sellerNavAlerts',
    countKeys: COUNT_KEYS,
    itemCountKeys: ITEM_COUNT_KEYS,
    activeItemId,
  });
}
